import React from "react";

import { Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Select from "ds/Select";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { capitalize } from "Libs/utils";
import { selectEnvironmentsOfType } from "Reducers/environment";

import * as S from "./EnvironmentTypeRow.styles";

import type { ConsoleAccessRole } from "@packages/client";

interface EnvironmentTypeRowProps {
  environmentType: string;
  disabled?: boolean;
  environment?: {
    role: string;
  };
  value?: ConsoleAccessRole | null;
  onChange: (e: any, meta: any) => void;
}

const EnvironmentTypeRow = ({
  environmentType,
  value,
  disabled = false,
  onChange
}: EnvironmentTypeRowProps) => {
  const intl = useIntl();
  const environments =
    useSelectorWithUrlParams(selectEnvironmentsOfType, {
      environmentType
    }) || [];

  const environmentNames = environments.map(e => e.name);

  const options = [
    {
      label: intl.formatMessage({
        id: "access.options.no_access"
      }),
      value: "no-access"
    },
    {
      label: intl.formatMessage({
        id: "access.options.admin"
      }),
      value: "admin"
    },
    {
      label: intl.formatMessage({
        id: "access.options.viewer"
      }),
      value: "viewer"
    },
    {
      label: intl.formatMessage({
        id: "access.options.contributor"
      }),
      value: "contributor"
    }
  ];

  const selected = options.find(o => o.value === value) || null;

  return (
    <S.EnvironmentTableRow>
      <S.EnvironmentTableCell width="20%">
        <Typography.Label>{capitalize(environmentType)}</Typography.Label>
      </S.EnvironmentTableCell>
      <S.EnvironmentTableCell width="35%">
        <S.SelectContainer>
          <Select
            isDisabled={disabled}
            id="access.options.select_permission"
            name={environmentType}
            onChange={onChange}
            value={selected}
            options={options}
            placeholder={intl.formatMessage({
              id: "access.options.select_permission"
            })}
          />
        </S.SelectContainer>
      </S.EnvironmentTableCell>
      <S.EnvironmentTableCell width="45%">
        <Typography.Label textStyle="lowercaseControl">
          {environmentNames.join(", ")}
        </Typography.Label>
      </S.EnvironmentTableCell>
    </S.EnvironmentTableRow>
  );
};

export default EnvironmentTypeRow;
